function NotFound() {
  return (
    <div style={{ padding: "100px", textAlign: "center" }}>
      <h1>404</h1>
      <p>Page Not Found</p>
    </div>
  );
}

export default NotFound;
